import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bots: [],
  activeBots: [],
  status: 'idle'
};

const botSlice = createSlice({
  name: 'bot',
  initialState,
  reducers: {
    setBots: (state, action) => {
      state.bots = action.payload;
    },
    setActiveBots: (state, action) => {
      state.activeBots = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    }
  }
});

export const { setBots, setActiveBots, setStatus } = botSlice.actions;
export default botSlice.reducer;